import Result from "slotworks/model/gameplay/records/results/result";
import Point from "slotworks/utils/geom/point";

export default class SymbolWinResult extends Result {

    /** For debugging purposes */
    public resultType: string = "ScatterResult";

    public symbolType: string;

    public symbols: string[] = [];

    public matches: number;

    public positions: Point[];
}
